import { useEffect, useState } from "react";
//-----------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyFormData } from "src/components/common/functions";
//-----------------------------------
export default function SettingsForm({
    closeIt
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [settings, setSettings] = useState({});
    const [showLoading, setShowLoading] = useState(true);
    useEffect(() => {
        let isMouted = true;
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("mode", "Read");
            const res = await myAxios("users/settings.php", formData);
            if(!isMouted) return;
            setShowLoader(false);
            if(!res) return;
            //-----------------------------------
            setSettings(res.data);
            setShowLoading(false);
        }
        getData();
        return () => { isMouted = false; }
    }, [setShowLoader])
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Settings"
            width = {1000} maxWidth = {"100%"}
        >
            {showLoading?
            <div className = "my-2">Loading...</div>
            :
            <>
            <div className = "my-2">
                <h4>Region</h4>
                <ul>
                    {settings.Region.map((u, key) => 
                    <li key = {key} className = "mt-2">
                        {u}
                        <span
                            className = "btn btn-danger ml-2"
                            onClick = {async() => {
                                if(!window.confirm("Are you sure to delete this region?")) return;
                                const formData = new MyFormData();
                                formData.append("mode", "Add");
                                setShowLoader(true);
                                const res = await myAxios("users/setttings.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                setSettings(settings);
                            }}
                        >
                            Delete
                        </span>
                    </li>)}
                </ul>
                <span
                    className = "btn btn-success"
                    onClick = {async() => {
                        const formData = new MyFormData();
                        formData.append("mode", "Add");
                        setShowLoader(true);
                        const res = await myAxios("users/setttings.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        setSettings(settings);
                    }}
                >
                    Add
                </span>
            </div>
            </>
            }
        </Modal>
    )
}